<div class='width-1100'>

  <mat-card>
    <mat-toolbar class="toolbar-top">

      <div class='title'>
        <mat-icon>bookmark</mat-icon>
        <div>
          <span>Certificados Palestrantes • </span>
          <span>{{title}}&nbsp;</span>
        </div>
      </div>

    </mat-toolbar>
  </mat-card>

  <div class='content'>

    <mat-card style="display: flex; flex-direction: row; justify-content: space-between;">
      <div style="display: flex; flex-direction: column; ">
        <mat-label>Eventos</mat-label>
        <mat-select (ngModelChange)="eventChange($event)" [ngModel]="selectedEvent"
          style="border: solid 1px silver; width: 800px; padding: 5px; margin: 5px 0 15px 0;">
          <mat-option *ngFor="let event of arrayEvents" [value]="event">
            <span>{{ event.name }}</span>
          </mat-option>
        </mat-select>
      </div>

      <div *ngIf="selectedEvent" style="margin-top: 20px;">
        <button mat-raised-button (click)='openCertificateConfigDialog()' style="margin-right: 10px;">
          Configurações
        </button>
      </div>

    </mat-card>

    <mat-card *ngIf="staffDataSource">
      <input class='filter' matInput (keyup)="applyFilter($event.target.value)" placeholder='filtro' autocomplete="off">

      <mat-table [dataSource]="staffDataSource"
        style='height: calc(100vh - 370px);  overflow:auto; margin: 0 0 10px 0;'>

        <ng-container matColumnDef="icon">
          <mat-header-cell *matHeaderCellDef> </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <mat-icon style='color:rgba(0,0,0,.8); font-size:1.4em;'>bookmark_border</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="member_name">
          <mat-header-cell *matHeaderCellDef> Palestrantes </mat-header-cell>
          <mat-cell *matCellDef="let element">
            <div style="margin: 15px;">
              <b>{{ element.member_name }}</b>
              <br>
              {{ element.type }}
              <div style='padding: 10px 0 10px 0;'>
                <div>• {{ element.event_name }}</div>
                <div>• {{ element.day_name }}</div>
                <div>• {{ element.activity_name }}</div>
                <div *ngIf="element.topic_name">• {{ element.topic_name }}</div>
              </div>
              <span style="color: darkblue;">{{element.certificate_url}}</span>
            </div>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="viewer">
          <mat-header-cell *matHeaderCellDef></mat-header-cell>
          <mat-cell *matCellDef="let element">
            <a *ngIf="element.certificate_url" matTooltip="Visualizar" target='_blank' href={{element.certificate_url}}>
              <mat-icon>remove_red_eye</mat-icon>
            </a>
          </mat-cell>
        </ng-container>

        <ng-container matColumnDef="selected">
          <mat-header-cell *matHeaderCellDef>
            <mat-checkbox color='primary' #checkboxStaff (change)='toggleCheckStaff(checkboxStaff.checked)'>
            </mat-checkbox>
          </mat-header-cell>
          <mat-cell *matCellDef="let element">

            <mat-checkbox color='primary' [(ngModel)]="element.selected">
            </mat-checkbox>

          </mat-cell>
        </ng-container>

        <mat-header-row class='mat-header-row' *matHeaderRowDef="displayedCertificateStaffColumns">
        </mat-header-row>

        <mat-row *matRowDef="let row; columns: displayedCertificateStaffColumns;">
        </mat-row>

      </mat-table>

    </mat-card>
  </div>

  <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
    <button *ngIf="subscriptionDataSource" mat-raised-button (click)='updateSubscriptionEnrollments()'>
      <mat-icon class='icon-done'>check_circle_outline</mat-icon>
    </button>
  </div>

</div>